import React, { useEffect, useState } from 'react';
import {
  View, Text, FlatList, TouchableOpacity, StyleSheet,
  ActivityIndicator, Alert,
} from 'react-native';
import { matchingAPI } from '../services/api';

function MatchCard({ item, onConfirm }) {
  return (
    <View style={styles.card}>
      <View style={styles.cardBadge}>
        <Text style={styles.badgeText}>🔗 Rota Complementar</Text>
      </View>

      <View style={styles.routeRow}>
        <View style={styles.routeBox}>
          <Text style={styles.routeLabel}>DE</Text>
          <Text style={styles.routeCity}>{item.rota_origem}</Text>
        </View>
        <Text style={styles.routeArrow}>→</Text>
        <View style={styles.routeBox}>
          <Text style={styles.routeLabel}>PARA</Text>
          <Text style={styles.routeCity}>{item.rota_destino}</Text>
        </View>
      </View>

      <Text style={styles.cardData}>
        📅 {new Date(item.data_inicio).toLocaleDateString('pt-BR', { day:'2-digit', month:'short', year:'numeric' })}
      </Text>

      <View style={styles.econBox}>
        <Text style={styles.econLabel}>💰 Economia estimada</Text>
        <Text style={styles.econValor}>R$ {item.economia_estimada}</Text>
        <Text style={styles.econPct}>(-{item.economia_porcentagem}% no custo de retorno)</Text>
      </View>

      <Text style={styles.cardVeiculo}>🚗 {item.modelo} · {item.placa}</Text>
      <Text style={styles.cardLocatario}>👤 Reservado por: {item.locatario_nome}</Text>

      <TouchableOpacity style={styles.btnConfirm} onPress={() => onConfirm(item)}>
        <Text style={styles.btnConfirmText}>✅  Aceitar este match</Text>
      </TouchableOpacity>
    </View>
  );
}

export default function MatchingScreen({ route, navigation }) {
  const { veiculo, origem, destino, data_inicio, data_fim } = route.params;
  const [matches,  setMatches]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [reservaId, setReservaId] = useState(null);

  useEffect(() => {
    buscarMatches();
  }, []);

  const buscarMatches = async () => {
    setLoading(true);
    try {
      const { data } = await matchingAPI.buscar({
        origem,
        destino,
        data:       data_inicio,
        veiculo_id: veiculo.veiculo_id,
      });
      setMatches(data.matches || []);
    } catch (err) {
      Alert.alert('Erro', err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async (match) => {
    if (!reservaId) {
      return Alert.alert(
        'Atenção',
        'Você precisa criar sua reserva primeiro. Volte e confirme a reserva, depois o match será aplicado automaticamente.',
        [{ text: 'Entendido' }]
      );
    }

    Alert.alert(
      'Confirmar Match',
      `Aceitar a rota complementar de ${match.rota_origem} → ${match.rota_destino}?\n\nVocê economizará R$ ${match.economia_estimada}!`,
      [
        { text: 'Cancelar', style: 'cancel' },
        {
          text: 'Confirmar',
          onPress: async () => {
            try {
              await matchingAPI.confirmar({ reserva_id_ida: reservaId, reserva_id_volta: match.reserva_id });
              Alert.alert('🎉 Match realizado!', 'Desconto aplicado com sucesso nas duas reservas!', [
                { text: 'OK', onPress: () => navigation.navigate('MyBookings') },
              ]);
            } catch (err) {
              Alert.alert('Erro', err.message);
            }
          },
        },
      ]
    );
  };

  const handlePularMatching = () => {
    navigation.navigate('BookingConfirm', {
      veiculo, origem, destino, data_inicio, data_fim,
    });
  };

  if (loading) {
    return (
      <View style={styles.center}>
        <ActivityIndicator size="large" color="#F5C518" />
        <Text style={styles.loadingText}>Buscando rotas complementares...</Text>
        <Text style={styles.loadingSubText}>Analisando trajetos que se encaixam com o seu 🔍</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {/* Banner explicativo */}
      <View style={styles.banner}>
        <Text style={styles.bannerIcon}>🗺️</Text>
        <View style={{ flex: 1 }}>
          <Text style={styles.bannerTitle}>Você vai de {origem} → {destino}</Text>
          <Text style={styles.bannerText}>
            Encontramos quem vai no sentido contrário! Combinando trajetos, ambos economizam.
          </Text>
        </View>
      </View>

      {matches.length === 0 ? (
        <View style={styles.emptyBox}>
          <Text style={styles.emptyIcon}>🛣️</Text>
          <Text style={styles.emptyTitle}>Nenhum match por agora</Text>
          <Text style={styles.emptyText}>
            Não há rotas complementares disponíveis para este período.{'\n'}
            Sua reserva será publicada e outros usuários poderão se conectar depois.
          </Text>
          <TouchableOpacity style={styles.btnContinuar} onPress={handlePularMatching}>
            <Text style={styles.btnContinuarText}>Continuar sem match →</Text>
          </TouchableOpacity>
        </View>
      ) : (
        <>
          <Text style={styles.matchCount}>
            {matches.length} rota{matches.length > 1 ? 's' : ''} complementar{matches.length > 1 ? 'es' : ''} encontrada{matches.length > 1 ? 's' : ''}
          </Text>
          <FlatList
            data={matches}
            keyExtractor={item => String(item.reserva_id)}
            renderItem={({ item }) => <MatchCard item={item} onConfirm={handleConfirm} />}
            contentContainerStyle={{ padding: 16, paddingBottom: 20 }}
            showsVerticalScrollIndicator={false}
            ListFooterComponent={
              <TouchableOpacity style={styles.btnPular} onPress={handlePularMatching}>
                <Text style={styles.btnPularText}>Continuar sem match</Text>
              </TouchableOpacity>
            }
          />
        </>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container:       { flex: 1, backgroundColor: '#f9f9f9' },
  center:          { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 32 },
  loadingText:     { marginTop: 16, fontSize: 16, fontWeight: 'bold', color: '#1a1a1a' },
  loadingSubText:  { marginTop: 8, fontSize: 14, color: '#888', textAlign: 'center' },
  banner:          { backgroundColor: '#1a1a1a', flexDirection: 'row', padding: 18, gap: 14, alignItems: 'center' },
  bannerIcon:      { fontSize: 36 },
  bannerTitle:     { fontSize: 14, fontWeight: 'bold', color: '#F5C518', marginBottom: 4 },
  bannerText:      { fontSize: 13, color: '#ccc', lineHeight: 18 },
  matchCount:      { fontSize: 13, color: '#888', padding: 16, paddingBottom: 4 },
  card:            { backgroundColor: '#fff', borderRadius: 16, padding: 18, marginBottom: 14, shadowColor: '#000', shadowOpacity: 0.07, shadowRadius: 8, elevation: 3 },
  cardBadge:       { backgroundColor: '#fff3c4', alignSelf: 'flex-start', borderRadius: 8, paddingHorizontal: 10, paddingVertical: 4, marginBottom: 14 },
  badgeText:       { fontSize: 12, fontWeight: 'bold', color: '#7a5a00' },
  routeRow:        { flexDirection: 'row', alignItems: 'center', gap: 12, marginBottom: 10 },
  routeBox:        { flex: 1, backgroundColor: '#f5f5f5', borderRadius: 10, padding: 12, alignItems: 'center' },
  routeLabel:      { fontSize: 10, color: '#aaa', fontWeight: '700', letterSpacing: 1 },
  routeCity:       { fontSize: 16, fontWeight: 'bold', color: '#1a1a1a', marginTop: 2 },
  routeArrow:      { fontSize: 22, color: '#F5C518', fontWeight: 'bold' },
  cardData:        { fontSize: 13, color: '#888', marginBottom: 12 },
  econBox:         { backgroundColor: '#f0fdf4', borderRadius: 12, padding: 14, marginBottom: 12 },
  econLabel:       { fontSize: 13, color: '#555' },
  econValor:       { fontSize: 24, fontWeight: '900', color: '#1a7a3e', marginTop: 2 },
  econPct:         { fontSize: 12, color: '#888', marginTop: 2 },
  cardVeiculo:     { fontSize: 13, color: '#666', marginBottom: 4 },
  cardLocatario:   { fontSize: 13, color: '#aaa', marginBottom: 14 },
  btnConfirm:      { backgroundColor: '#F5C518', borderRadius: 12, paddingVertical: 14, alignItems: 'center' },
  btnConfirmText:  { fontSize: 15, fontWeight: 'bold', color: '#1a1a1a' },
  emptyBox:        { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 36 },
  emptyIcon:       { fontSize: 64, marginBottom: 16 },
  emptyTitle:      { fontSize: 20, fontWeight: 'bold', color: '#1a1a1a', marginBottom: 10 },
  emptyText:       { fontSize: 14, color: '#888', textAlign: 'center', lineHeight: 22, marginBottom: 28 },
  btnContinuar:    { backgroundColor: '#F5C518', borderRadius: 12, paddingHorizontal: 32, paddingVertical: 14 },
  btnContinuarText:{ fontSize: 15, fontWeight: 'bold', color: '#1a1a1a' },
  btnPular:        { alignItems: 'center', paddingVertical: 16 },
  btnPularText:    { color: '#888', fontSize: 14, textDecorationLine: 'underline' },
});
